import { render } from "./UsersManagement.vue?vue&type=template&id=485026c9&scoped=true"
import script from "./UsersManagement.vue?vue&type=script&lang=js"
export * from "./UsersManagement.vue?vue&type=script&lang=js"

import "./UsersManagement.vue?vue&type=style&index=0&id=485026c9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-485026c9"]])

export default __exports__